/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import TextError from "utils/TextError";
import * as Yup from "yup";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard standardized components
import CreateButton from "components/standardized-components/CreateButton";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createDynamicColumn,
  createOperationMachineMap,
  deleteOperationMachineMap,
  getDynamicColumn,
  getMachineCenterForDropDown,
  getMappedMachines,
  getOperationMachineMap,
  getOperationsForDropDown,
  getPrintersForLabelCreation,
  getSubModulesByRoleId,
  updateOperationMachineMap,
} from "../../store";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import { addMinutes, format } from "date-fns";
import Select from "react-select";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForItemsViewModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "fit-content",
  maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  overflow: "scroll",
  width: { xs: 350, lg: 800 },
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const OperationMachineMap = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getOperationMachineMap,
  getOperationMachineMapReducer,
  createOperationMachineMap,
  updateOperationMachineMap,
  getDynamicColumnReducer,
  getMachineCenterForDropDown,
  deleteOperationMachineMap,
  getMachineCenterForDropDownReducer,
  getOperationsForDropDown,
  getOperationsForDropDownReducer,
  getDynamicColumn,
  createDynamicColumn,
  getPrintersForLabelCreation,
  getPrintersForLabelCreationReducer,
  getMappedMachines,
  getMappedMachinesReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;

  let roleId = loginDetails?.data?.roleId;
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  const subModuleId = "174eb72f-8d16-4bbf-ad0b-884f91173219";

  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let labelCreation = modulesData.find(
    (moduleId) => moduleId.moduleId == "174eb72f-8d16-4bbf-ad0b-884f91173219",
  );
  let createAccess = labelCreation
    ? labelCreation.actionId.includes("9ee7d3eb-add6-46e8-893a-b32a1e102da4")
    : null;
  let viewAccess = labelCreation
    ? labelCreation.actionId.includes("2b283145-5be7-464b-89f8-d3c9efd2eb81")
    : null;
  let editAccess = labelCreation ? labelCreation.actionId.includes("") : null;
  let deleteAccess = labelCreation ? labelCreation.actionId.includes("") : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [categoryCode, setCategoryCode] = useState("");
  const [woCode, setWoCode] = useState("");
  const [workCenterId, setWorkCenterId] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [operationMachineMapId, setOperationMachineMapId] = useState("");
  console.log("operationMachineMapId", operationMachineMapId);
  useEffect(() => {
    getMachineCenterForDropDown(jwtToken);
  }, []);
  useEffect(() => {
    viewAccess &&
      getOperationMachineMap(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewAccess, pageNo, rowsPerPage, searchObject]);

  const [state, setState] = useState({
    columns: [
      { Header: "operation Code", accessor: "operationCode" },

      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value)?.getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "action",
        accessor: "action",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const [loading, setLoading] = useState(true);

  const { columns, rows } = state;

  const [viewItemsData, setViewItemsData] = useState([]);
  const [isErrorAddMapping, setIsErrorAddMapping] = useState(false);
  const [isSuccessAddMapping, setIsSuccessAddMapping] = useState(false);

  useEffect(() => {
    if (isErrorAddMapping) {
      setTimeout(() => {
        setIsErrorAddMapping(false);
      }, 3000);
    }
  }, [isErrorAddMapping]);

  useEffect(() => {
    if (isSuccessAddMapping) {
      setTimeout(() => {
        setIsSuccessAddMapping(false);
      }, 3000);
    }
  }, [isSuccessAddMapping]);

  const [openAddMappingModal, setOpenAddMappingModal] = useState(false);
  const [dataForAddingItem, setDataForAddingItem] = useState({});
  console.log("dataForAddingItem", dataForAddingItem);

  const handleOpenAddMappingModal = (data) => {
    setDataForAddingItem(data);
    setOpenAddMappingModal(true);
  };

  const handleCloseAddMappingModal = () => {
    setOpenAddMappingModal(false);
    setDocumentTypeSelected("");
  };

  const initialValueForAddMapping = {
    itemCode: "",
  };

  const validationSchemaForAddMapping = Yup.object({
    // itemCode: Yup.object().required("Select the item!"),
  });

  const [errorMsgForAdd, setErrorMsgForAdd] = useState("");

  const [addButtonName, setAddButtonName] = useState("Submit");
  const onSubmitForAddMapping = async (values, { resetForm }) => {
    setAddButtonName("Please wait...");
    let payload = {
      machineCenterId: controlTypeSelectedForEdit.value,
      operationId: dataForAddingItem?.operationId,
      operationMachineMapId: dataForAddingItem?.operationMachineMapId,
    };
    console.log(payload);
    let res = await updateOperationMachineMap(payload, jwtToken);

    if (res.status) {
      setIsSuccessAddMapping(true);
      getOperationMachineMap(pageNo, rowsPerPage, searchObject, jwtToken);
      setDocumentTypeSelected("");

      setTimeout(() => {
        handleCloseAddMappingModal();
        setAddButtonName("Submit");
      }, 2250);

      resetForm();
    }
    if (!res.status) {
      setErrorMsgForAdd(res?.data?.data?.msg);
      setIsErrorAddMapping(true);
      setAddButtonName("Submit");
    }
  };

  const formikForAddMapping = useFormik({
    initialValues: initialValueForAddMapping,
    // validationSchema: validationSchemaForAddMapping,
    onSubmit: onSubmitForAddMapping,
  });

  const [isErrorRemoveMapping, setIsErrorRemoveMapping] = useState(false);
  const [isSuccessRemoveMapping, setIsSuccessRemoveMapping] = useState(false);

  useEffect(() => {
    if (isErrorRemoveMapping) {
      setTimeout(() => {
        setIsErrorRemoveMapping(false);
      }, 3000);
    }
  }, [isErrorRemoveMapping]);

  useEffect(() => {
    if (isSuccessRemoveMapping) {
      setTimeout(() => {
        setIsSuccessRemoveMapping(false);
      }, 3000);
    }
  }, [isSuccessRemoveMapping]);

  const [openRemoveMappingModal, setOpenRemoveMappingModal] = useState(false);
  const [dataForRemovingItem, setDataForRemovingItem] = useState({});

  const handleOpenRemoveMappingModal = (data) => {
    setDataForRemovingItem(data);
    setOpenRemoveMappingModal(true);
  };

  const handleCloseRemoveMappingModal = () => {
    setOpenRemoveMappingModal(false);
    setDocumentTypeSelected("");
  };

  const initialValueForRemoveMapping = {
    itemCode: "",
  };

  const validationSchemaForRemoveMapping = Yup.object({
    itemCode: Yup.object().required("Select the item!"),
  });

  const [errorMsgForRemove, setErrorMsgForRemove] = useState("");
  const [removeButtonName, setRemoveButtonName] = useState("Submit");

  const onSubmitForRemoveMapping = async (values, { resetForm }) => {
    setRemoveButtonName("Please wait...");
    let payload = {
      machineCenterId: controlTypeSelectedForEdit.value,
      operationId: dataForRemovingItem?.operationId,
      operationMachineMapId: dataForRemovingItem?.operationMachineMapId,
    };

    let res = await updateOperationMachineMap(payload, jwtToken);

    if (res.status) {
      setIsSuccessRemoveMapping(true);
      getOperationMachineMap(pageNo, rowsPerPage, searchObject, jwtToken);
      setDocumentTypeSelected("");

      setTimeout(() => {
        handleCloseRemoveMappingModal();
        setRemoveButtonName("Submit");
      }, 2250);

      resetForm();
    }
    if (!res.status) {
      setErrorMsgForRemove(res?.data?.data?.msg);
      setIsErrorRemoveMapping(true);
      setRemoveButtonName("Submit");
    }
  };

  const formikForRemoveMapping = useFormik({
    initialValues: initialValueForRemoveMapping,
    validationSchema: validationSchemaForRemoveMapping,
    onSubmit: onSubmitForRemoveMapping,
  });

  const [viewItemsTable, setViewItemsTable] = useState({
    columns: [
      { Header: "Machine Code", accessor: "machineCode" },
      { Header: "make", accessor: "make" },
      { Header: "model", accessor: "model" },
    ],
    rows: [],
  });

  const { columns: viewItemsColumns, rows: viewItemsRows } = viewItemsTable;

  const [openViewItemsModal, setOpenViewItemsModal] = useState(false);

  const handleOpenViewItemsModal = (data) => {
    setViewItemsData(data);
    setOpenViewItemsModal(true);
  };

  const handleCloseViewItemsModal = () => {
    setOpenViewItemsModal(false);
  };

  useEffect(() => {
    let tempData = [];
    let data = viewItemsData ? viewItemsData : [];
    data &&
      data.length > 0 &&
      data.map((item) => {
        const formatDate = new Date(item && item.cd);

        const itemObj = {
          machineCode: item.machineCode,
          // itemDescription: item.itemDescription,
          make: item.make,
          model: item.model,

          cd: item && item.cd,
        };
        tempData.push(itemObj);
      });

    setViewItemsTable({ ...viewItemsTable, rows: tempData });
  }, [viewItemsData]);

  useEffect(() => {
    let tempLabels = [];
    let data = getOperationMachineMapReducer.labels.data
      ? getOperationMachineMapReducer.labels.data
      : [];

    setPaginationObj(getOperationMachineMapReducer?.labels?.pagination);
    setLoading(getOperationMachineMapReducer.loading);

    data &&
      data[0]?.cd &&
      data.map((label) => {
        const formatDate = new Date(label && label.cd);
        const labelObject = {
          operationCode: label.operationCode,
          integrationOption: label.integrationOption,
          machineCode: label.machineCode,
          make: label.make,
          model: label.model,
          locationId: label.locationId,
          createdDate: format(
            addMinutes(formatDate, formatDate?.getTimezoneOffset()),
            "dd/MM/yyyy hh:mm aaa",
          ),
          cd: label && label.cd,
          action: label.labelId !== 1 && (
            <div>
              <div>
                <Tooltip title="Add Machine">
                  <MDButton
                    // disabled={!addAccess}
                    variant="gradient"
                    color="success"
                    iconOnly
                    size="small"
                    type="button"
                    onClick={() => {
                      setCategoryCode(label.operationCode);
                      setWorkCenterId(label.workCenterId);
                      setWoCode(label.woCode);
                      // setCategoryName(label.categoryName);
                      setOperationMachineMapId(label.operationMachineMapId);
                      handleOpenAddMappingModal(label);
                      getMachineCenterForDropDown(jwtToken);
                      getOperationsForDropDown(jwtToken);
                    }}
                    style={{ marginRight: "5px" }}
                  >
                    <Icon>add</Icon>
                  </MDButton>
                </Tooltip>

                <Tooltip title="Remove Machine">
                  <MDButton
                    // disabled={!removeAccess}
                    variant="gradient"
                    color="error"
                    iconOnly
                    size="small"
                    type="button"
                    style={{ marginRight: "5px" }}
                    onClick={() => {
                      setViewItemsData(label.items);
                      setCategoryCode(label.operationCode);
                      // setCategoryName(label.categoryName);
                      handleOpenRemoveMappingModal(label);
                      getMappedMachines(label.operationId, jwtToken);
                      getOperationsForDropDown(jwtToken);
                    }}
                  >
                    <Icon>remove</Icon>
                  </MDButton>
                </Tooltip>

                <Tooltip title="View Machines">
                  <MDButton
                    variant="gradient"
                    // disabled={!viewMapping}
                    color="info"
                    iconOnly
                    size="small"
                    type="button"
                    style={{ marginRight: "5px" }}
                    onClick={() => {
                      setCategoryCode(label.operationCode);
                      setCategoryName(label.categoryName);
                      handleOpenViewItemsModal(label?.machineData);
                    }}
                  >
                    <Icon>visibility</Icon>
                  </MDButton>
                </Tooltip>
              </div>
              {/* {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                // size="small"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateLabelModal(label)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}

            {deleteAccess && (
              <DeleteButton
                tooltip="Delete "
                variant="gradient"
                color="error"
                iconOnly
                // size="small"
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteLabelModal(label)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )} */}
            </div>
          ),
        };
        tempLabels.push(labelObject);
      });

    setState({ ...state, rows: tempLabels });
  }, [getOperationMachineMapReducer]);

  const [assetTypeSelected, setAssetTypeSelected] = useState("");
  const [mrpPrinterSelected, setMrpPrinterSelected] = useState("");

  const [assetTypeForEditSelected, setAssetTypeForEditSelected] = useState("");
  const [mrpPrinterForEditSelected, setMrpPrinterForEditSelected] =
    useState("");
  const [assetTypeOptions, setAssetTypeOptions] = useState([]);

  const [documentTypeSelected, setDocumentTypeSelected] = useState("");
  const handleDocumentTypeChange = (selectedValue) => {
    setDocumentTypeSelected(selectedValue);
  };
  useEffect(() => {
    let tempAssetTypeOptions = [];
    let data = getPrintersForLabelCreationReducer.printers.data
      ? getPrintersForLabelCreationReducer.printers.data
      : [];

    data.map((asset) => {
      tempAssetTypeOptions.push({
        label: asset.assetName,
        value: asset.assetId,
      });
    });

    setAssetTypeOptions(tempAssetTypeOptions);
  }, [getPrintersForLabelCreationReducer]);

  const [operationSelected, setOperationSelected] = useState("");
  const [operationOptions, setOperationOptions] = useState("");

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getOperationsForDropDownReducer.labels.data
      ? getOperationsForDropDownReducer.labels.data
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.operationCode,
        value: activity.operationId,
      });
    });
    setOperationOptions(tempCreatedActivityOptions);
  }, [getOperationsForDropDownReducer]);

  const handleOperationChange = (selectedValue) => {
    setOperationSelected(selectedValue);
  };

  const handleAssetTypeChange = (selectedZone) => {
    setAssetTypeSelected(selectedZone);
  };

  const handleMrpPrinterChange = (selectedZone) => {
    setMrpPrinterSelected(selectedZone);
  };

  const handleAssetTypeForEditChange = (selectedZone) => {
    setAssetTypeForEditSelected(selectedZone);
  };

  const handleMrpPrinterForEditChange = (selectedZone) => {
    setMrpPrinterForEditSelected(selectedZone);
  };

  const [isErrorCreateLabel, setIsErrorCreateLabel] = useState(false);
  const [isSuccessCreateLabel, setIsSuccessCreateLabel] = useState(false);

  const [openCreateLabelModal, setOpenCreateLabelModal] = useState(false);

  useEffect(() => {
    if (isErrorCreateLabel) {
      setTimeout(() => {
        setIsErrorCreateLabel(false);
      }, 3000);
    }
  }, [isErrorCreateLabel]);

  useEffect(() => {
    if (isSuccessCreateLabel) {
      setTimeout(() => {
        setIsSuccessCreateLabel(false);
      }, 3000);
    }
  }, [isSuccessCreateLabel]);

  const handleOpenCreateLabelModal = () => {
    setOpenCreateLabelModal(true);
    getPrintersForLabelCreation(jwtToken);
    getOperationsForDropDown(jwtToken);
    formikForCreateLabel.setValues(initialValueForCreateLabel);
    formikForCreateLabel.setTouched({});
    formikForCreateLabel.setErrors({});
    setDocumentTypeSelected("");
  };

  const handleCloseCreateLabelModal = () => {
    setOpenCreateLabelModal(false);
    setDocumentTypeSelected("");
  };

  const initialValueForCreateLabel = {
    machineCode: "",
    operation: "",
  };

  const validationSchema = Yup.object({
    machineCode: Yup.string().required("Select the Machine code!"),
    operation: Yup.string().required("Select the Operation Code!"),
  });

  const [mappedMachinesOptions, setMappedMachinesOptions] = useState("");

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getMappedMachinesReducer.labels.data
      ? getMappedMachinesReducer.labels.data
      : [];
    data &&
      data.length > 0 &&
      data.map((activity) => {
        tempCreatedActivityOptions.push({
          label: activity.machineCode,
          value: activity.machineCenterId,
        });
      });
    setMappedMachinesOptions(tempCreatedActivityOptions);
  }, [getMappedMachinesReducer]);

  const [machineOptions, setMachineOptions] = useState("");

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getMachineCenterForDropDownReducer.labels.data
      ? getMachineCenterForDropDownReducer.labels.data
      : [];
    data &&
      data.length > 0 &&
      data.map((activity) => {
        tempCreatedActivityOptions.push({
          label: activity.machineCode,
          value: activity.machineCenterId,
        });
      });
    setMachineOptions(tempCreatedActivityOptions);
  }, [getMachineCenterForDropDownReducer]);

  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");

  const [buttonName, setButtonName] = useState("Create");

  const onSubmitForCreateLabel = async (values, { resetForm }) => {
    let payload = {
      operationId: operationSelected?.value,
      machineCenterId: documentTypeSelected?.value,
      // userId: userId,
    };
    setButtonName("Please wait...");
    let res = await createOperationMachineMap(payload, jwtToken);

    if (res.status) {
      setIsSuccessCreateLabel(true);
      getOperationMachineMap(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseCreateLabelModal();
        setButtonName("Create");
      }, 2250);

      resetForm();
    }
    if (!res.status) {
      setErrorMsgForCreate(res?.data?.data?.msg);
      setIsErrorCreateLabel(true);
      setButtonName("Create");
    }
  };

  const formikForCreateLabel = useFormik({
    initialValues: initialValueForCreateLabel,
    // validationSchema: validationSchema,
    onSubmit: onSubmitForCreateLabel,
  });

  const [singleLabelDataForDelete, setSingleLabelDataForDelete] = useState({});
  const [openDeleteLabelModal, setOpenDeleteLabelModal] = useState(false);

  const handleOpenDeleteLabelModal = (data = {}) => {
    setSingleLabelDataForDelete(data);
    setOpenDeleteLabelModal(true);
  };
  const handleCloseDeleteLabelModal = () => {
    setOpenDeleteLabelModal(false);
  };

  const [isErrorDeleteLabel, setIsErrorDeleteLabel] = useState(false);
  const [isSuccessDeleteLabel, setIsSuccessDeleteLabel] = useState(false);

  useEffect(() => {
    if (isErrorDeleteLabel) {
      setTimeout(() => {
        setIsErrorDeleteLabel(false);
      }, 3000);
    }
  }, [isErrorDeleteLabel]);

  useEffect(() => {
    if (isSuccessDeleteLabel) {
      setTimeout(() => {
        setIsSuccessDeleteLabel(false);
      }, 3000);
    }
  }, [isSuccessDeleteLabel]);

  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteLabelHandler = async () => {
    setDeleteButtonName("Please wait...");
    let operationId = singleLabelDataForDelete.operationId;
    let response = await deleteOperationMachineMap(operationId, jwtToken);

    if (response.status) {
      setIsSuccessDeleteLabel(true);
      getOperationMachineMap(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseDeleteLabelModal();
        setDeleteButtonName("Delete");
      }, 2250);
    }
    if (!response.status) {
      setErrorMsgForDelete(response?.data?.data?.msg);
      setIsErrorDeleteLabel(true);
      setDeleteButtonName("Delete");
    }
  };

  const [workCenterSelected, setWorkCenterSelected] = useState("");

  const handleChangeWorkCenterType = (selectedOption) => {
    setWorkCenterSelected(selectedOption);
  };

  const [openUpdateLabelModal, setOpenUpdateLabelModal] = useState(false);
  const [singleLabelDataForUpdate, setLabelDataForUpdate] = useState({});

  const handleOpenUpdateLabelModal = (data = {}) => {
    setLabelDataForUpdate(data);
    setControlTypeSelectedForEdit({
      label: data?.machineCode,
      value: data?.machineCenterId,
    });
    setMrpPrinterForEditSelected({
      label: data?.mrpAssetName,
      value: data?.mrpPrinterIpId,
    });
    setOpenUpdateLabelModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
    getPrintersForLabelCreation(jwtToken);
  };

  const handleCloseUpdateLabelModal = () => {
    setOpenUpdateLabelModal(false);
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    // workCenterId: singleLabelDataForUpdate.workCenterId,
    // make: singleLabelDataForUpdate.make,
    // model: singleLabelDataForUpdate.model,
    woCode: singleLabelDataForUpdate.operationCode,
    // location: singleLabelDataForUpdate.locationId,
    // suidPrinterIpId: singleLabelDataForUpdate.suidPrinterIpId,
    // mrpPrinterIpId: singleLabelDataForUpdate.mrpPrinterIpId,
  };

  const validationSchemaForUpdate = Yup.object({
    machineCode: Yup.string().required("Enter the Machine code!"),
    make: Yup.string().required("Enter the Make!"),
    model: Yup.string().required("Enter the Model!"),
    woCode: Yup.string().required("Enter the woCode!"),
    location: Yup.string().required("Enter the Location!"),
  });

  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  const [editButtonName, setEditButtonName] = useState("Submit");

  const [controlTypeSelectedForEdit, setControlTypeSelectedForEdit] =
    useState("");

  const handleChangeControlTypeForEdit = (selectedOption) => {
    setControlTypeSelectedForEdit(selectedOption);
  };

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      operationId: singleLabelDataForUpdate.operationId,
      operationCode: values.woCode,
      machineCenterId: controlTypeSelectedForEdit?.value,
      // userId: userId,
    };
    let res = await updateOperationMachineMap(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getOperationMachineMap(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        setEditButtonName("Submit");
        handleCloseUpdateLabelModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getOperationMachineMap(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={0} pb={3} mb={-2.5}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox color="text" p={0} px={2} mt={0} mb={-2}>
                  {createAccess ? (
                    <MDBox color="text" px={2} ml={-2} mb={1}>
                      <CreateButton
                        tooltip="Create"
                        color="info"
                        variant="contained"
                        type="button"
                        onClick={handleOpenCreateLabelModal}
                        style={{ marginRight: "10px" }}
                        // size="small"
                        iconOnly
                      >
                        <Icon>add</Icon>
                      </CreateButton>
                    </MDBox>
                  ) : (
                    <MDBox color="text" px={2} ml={-2} mb={1}>
                      <CreateButton
                        tooltip="Create"
                        disabled
                        color="info"
                        variant="contained"
                        type="button"
                        onClick={handleOpenCreateLabelModal}
                        style={{ marginRight: "10px" }}
                        iconOnly
                      >
                        <Icon>add</Icon>
                      </CreateButton>
                    </MDBox>
                  )}
                </MDBox>

                <MDBox pt={3}>
                  {loadingForDynamicColumn && (
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                      options={{ draggable: false }}
                      serverSidePagination={true}
                      paginationObj={paginationObj}
                      pageNoValue={pageNo}
                      rowsPerPageValue={rowsPerPage}
                      pageNoProp={importPageNo}
                      rowsPerPageProp={importRowsPerPage}
                      searchProp={importSearch}
                      loading={loading}
                      hideColumns={hiddenColumsDetails}
                      visibleColumns2={dynamicColumnData?.visibleFields}
                      dynamicColumnData={dynamicColumnData}
                      handleOpenCreateColumnReorderModal={
                        handleOpenCreateColumnReorderModal
                      }
                      subModuleId={subModuleId}
                      userId={userId}
                    />
                  )}
                </MDBox>
                <Modal
                  open={openCreateLabelModal}
                  onClose={handleCloseCreateLabelModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Create
                      </MDTypography>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseCreateLabelModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForCreateLabel.handleSubmit}
                      >
                        <MDBox>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Operation Code
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={130}
                              placeholder="Select Document Type..."
                              name="operation"
                              value={operationSelected}
                              options={operationOptions}
                              onChange={(selectedOption) => {
                                handleOperationChange(selectedOption);
                                formikForCreateLabel.setFieldValue(
                                  "operation",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForCreateLabel.errors.operation &&
                              formikForCreateLabel.touched.operation && (
                                <TextError
                                  msg={formikForCreateLabel.errors.operation}
                                />
                              )}
                          </MDBox>{" "}
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Machine Code
                            </MDTypography>

                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={130}
                              menuPlacement="top"
                              menuPosition="absolute"
                              placeholder="Select Document Type..."
                              name="documentType"
                              value={documentTypeSelected}
                              options={machineOptions}
                              onChange={(selectedOption) => {
                                handleDocumentTypeChange(selectedOption);
                                formikForCreateLabel.setFieldValue(
                                  "documentType",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForCreateLabel.errors.documentType && (
                              <TextError
                                msg={formikForCreateLabel.errors.documentType}
                              />
                            )}
                          </MDBox>
                          <MDBox mt={2}>
                            <Collapse in={isSuccessCreateLabel}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessCreateLabel(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Mapped successfully!
                              </Alert>
                            </Collapse>
                            <Collapse in={isErrorCreateLabel}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorCreateLabel(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForCreate}
                              </Alert>
                            </Collapse>
                          </MDBox>
                          <div className="mt-3">
                            <MDButton
                              type="submit"
                              variant="gradient"
                              color="info"
                              fullWidth
                              disabled={
                                buttonName === "Please wait..." ||
                                !operationSelected ||
                                !documentTypeSelected
                              }
                            >
                              {buttonName}
                            </MDButton>
                          </div>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>

                <Modal
                  open={openUpdateLabelModal}
                  onClose={handleCloseUpdateLabelModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Edit Label
                      </MDTypography>
                      <MDBox>
                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseUpdateLabelModal}
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForUpdate.handleSubmit}
                      >
                        {/* <MDBox mb={2}>
                          <MDTypography variant="h6">Machine Code</MDTypography>
                          <MDInput
                            type="text"
                            name="machineCode"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={formikForUpdate.values.machineCode}
                            error={
                              formikForUpdate.touched.machineCode &&
                              formikForUpdate.errors.machineCode &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched.machineCode &&
                            formikForUpdate.errors.machineCode && (
                              <TextError
                                msg={formikForUpdate.errors.machineCode}
                              />
                            )}
                        </MDBox> */}
                        {/* <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Make
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="make"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={formikForUpdate.values.make}
                            error={
                              formikForUpdate.touched.make &&
                              formikForUpdate.errors.make &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched.make &&
                            formikForUpdate.errors.make && (
                              <TextError
                                msg={formikForUpdate.errors.make}
                              />
                            )}
                        </MDBox>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Model
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="model"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={formikForUpdate.values.model}
                            error={
                              formikForUpdate.touched.model &&
                              formikForUpdate.errors.model &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched.model &&
                            formikForUpdate.errors.model && (
                              <TextError
                                msg={formikForUpdate.errors.model}
                              />
                            )}
                        </MDBox> */}
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Operation Code
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="woCode"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={formikForUpdate.values.woCode}
                            error={
                              formikForUpdate.touched.woCode &&
                              formikForUpdate.errors.woCode &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched.woCode &&
                            formikForUpdate.errors.woCode && (
                              <TextError msg={formikForUpdate.errors.woCode} />
                            )}
                        </MDBox>
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            fontWeight="medium"
                            style={{ fontWeight: "500" }}
                          >
                            Machine Code
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="workCenter"
                            value={controlTypeSelectedForEdit}
                            options={machineOptions}
                            onChange={(selectedOption) => {
                              handleChangeControlTypeForEdit(selectedOption);
                              formikForUpdate.setFieldValue(
                                "workCenter",
                                selectedOption,
                              );
                            }}
                          />
                          {formikForUpdate.errors.workCenter && (
                            <TextError
                              msg={formikForUpdate.errors.workCenter}
                            />
                          )}
                        </MDBox>
                        {/* 
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            SUID Printer
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={180}
                            placeholder="Select ..."
                            name="suidPrinterIpId"
                            value={assetTypeForEditSelected}
                            options={assetTypeOptions}
                            onChange={(selectedOption) => {
                              handleAssetTypeForEditChange(selectedOption);
                              formikForUpdate.setFieldValue(
                                "suidPrinterIpId",
                                selectedOption
                              );
                            }}
                          />
                          {formikForUpdate.errors.suidPrinterIpId && (
                            <TextError
                              msg={formikForUpdate.errors.suidPrinterIpId}
                            />
                          )}
                        </MDBox>

                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            MRP Printer
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={180}
                            placeholder="Select ..."
                            name="mrpPrinterIpId"
                            value={mrpPrinterForEditSelected}
                            options={assetTypeOptions}
                            onChange={(selectedOption) => {
                              handleMrpPrinterForEditChange(selectedOption);
                              formikForUpdate.setFieldValue(
                                "mrpPrinterIpId",
                                selectedOption
                              );
                            }}
                          />
                          {formikForUpdate.errors.mrpPrinterIpId && (
                            <TextError
                              msg={formikForUpdate.errors.mrpPrinterIpId}
                            />
                          )}
                        </MDBox> */}

                        <MDBox>
                          <Collapse in={isErrorForUpdate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForUpdate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessForUpdate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Updated successfully!
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            variant="contained"
                            color="success"
                            fullWidth
                            type="submit"
                            disabled={editButtonName === "Please wait..."}
                          >
                            {editButtonName}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openDeleteLabelModal}
                  onClose={handleCloseDeleteLabelModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={deleteStyle}>
                    <MDTypography>
                      Are you sure you want to delete?
                    </MDTypography>
                    <MDBox mt={2} display="flex">
                      <div>
                        <MDButton
                          style={{ width: "100%", marginRight: "0.5rem" }}
                          color="info"
                          variant="outlined"
                          onClick={handleCloseDeleteLabelModal}
                        >
                          Cancel
                        </MDButton>
                      </div>
                      <div style={{ float: "right" }}>
                        <MDButton
                          style={{ width: "100%", marginLeft: "0.5rem" }}
                          color="error"
                          onClick={deleteLabelHandler}
                          disabled={deleteButtonName === "Please wait..."}
                        >
                          {deleteButtonName}
                        </MDButton>
                      </div>
                    </MDBox>
                    <MDBox mt={2}>
                      <Collapse in={isSuccessDeleteLabel}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessDeleteLabel(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Deleted successfully!
                        </Alert>
                      </Collapse>
                      <Collapse in={isErrorDeleteLabel}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorDeleteLabel(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForDelete}
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDCard>
                </Modal>

                <Modal
                  open={openAddMappingModal}
                  onClose={handleCloseAddMappingModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Add Machine
                      </MDTypography>
                      <MDBox>
                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseAddMappingModal}
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForAddMapping.handleSubmit}
                      >
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Select the Machine
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={90}
                            placeholder="Select Item..."
                            name="machine"
                            value={controlTypeSelectedForEdit}
                            options={machineOptions}
                            onChange={(selectedOption) => {
                              handleChangeControlTypeForEdit(selectedOption);
                              formikForAddMapping.setFieldValue(
                                "machine",
                                selectedOption,
                              );
                            }}
                          />
                          {formikForAddMapping.errors.machine && (
                            <TextError
                              msg={formikForAddMapping.errors.machine}
                            />
                          )}
                        </MDBox>

                        <MDBox>
                          <Collapse in={isErrorAddMapping}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorAddMapping(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForAdd}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessAddMapping}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsSuccessAddMapping(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Machine added successfully!
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            variant="contained"
                            color="success"
                            fullWidth
                            type="submit"
                            disabled={
                              !controlTypeSelectedForEdit ||
                              addButtonName === "Please wait..."
                            }
                          >
                            {addButtonName}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openRemoveMappingModal}
                  onClose={handleCloseRemoveMappingModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Remove Machine
                      </MDTypography>
                      <MDBox>
                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseRemoveMappingModal}
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForRemoveMapping.handleSubmit}
                      >
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Select the Machine
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={90}
                            placeholder="Select Machine..."
                            name="machine"
                            value={controlTypeSelectedForEdit}
                            options={mappedMachinesOptions}
                            onChange={(selectedOption) => {
                              handleChangeControlTypeForEdit(selectedOption);
                              formikForAddMapping.setFieldValue(
                                "machine",
                                selectedOption,
                              );
                            }}
                          />
                          {formikForRemoveMapping.errors.machine && (
                            <TextError
                              msg={formikForRemoveMapping.errors.machine}
                            />
                          )}
                        </MDBox>

                        <MDBox>
                          <Collapse in={isErrorRemoveMapping}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorRemoveMapping(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForRemove}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessRemoveMapping}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsSuccessRemoveMapping(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Machine removed successfully!
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            variant="contained"
                            color="success"
                            fullWidth
                            type="submit"
                            disabled={
                              !controlTypeSelectedForEdit ||
                              removeButtonName === "Please wait..."
                            }
                          >
                            {removeButtonName}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openViewItemsModal}
                  onClose={handleCloseViewItemsModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={styleForItemsViewModal}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Machines
                      </MDTypography>

                      <MDBox>
                        <span>
                          <Tooltip title="Close">
                            <IconButton
                              style={{
                                background: "whitesmoke",
                                color: "black",
                                borderRadius: 5,
                                marginLeft: "-55px",
                                marginBottom: "5px",
                              }}
                              aria-label="close"
                              color="inherit"
                              onClick={handleCloseViewItemsModal}
                            >
                              <CloseIcon />
                            </IconButton>
                          </Tooltip>
                        </span>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginBottom: "1rem" }} />
                    <div style={{ display: "flex" }}>
                      <MDTypography variant="h5" style={{ marginLeft: "2rem" }}>
                        Operation Code:{" "}
                        <span style={{ fontWeight: 400 }}>{categoryCode}</span>
                      </MDTypography>
                    </div>

                    <MDBox>
                      <DataTable
                        table={{
                          columns: viewItemsColumns,
                          rows: viewItemsRows,
                        }}
                        isSorted={true}
                        tableSearch={true}
                        entriesPerPage={{
                          defaultValue: 5,
                          entries: [5, 10, 15, 20, 25, 30],
                        }}
                        showTotalEntries={true}
                        noEndBorder
                      />
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openCreateColumnReorderModal}
                  onClose={handleCloseCreateColumnReorderModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={styleForColumnReorder}>
                    <MDTypography>
                      Are you sure you want to submit?
                    </MDTypography>
                    <MDBox mt={2}>
                      <MDButton
                        style={{ width: "10rem", marginRight: "0.5rem" }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseCreateColumnReorderModal}
                      >
                        Cancel
                      </MDButton>
                      <MDButton
                        style={{ width: "10rem", marginLeft: "0.5rem" }}
                        color="success"
                        onClick={handleDynamicColumn}
                      >
                        Submit
                      </MDButton>
                    </MDBox>
                    <MDBox mt={2}>
                      <Collapse in={isSuccessColumnReorder}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessColumnReorder(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Data updated successfully!
                        </Alert>
                      </Collapse>
                      <Collapse in={isErrorColumnReorder}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorColumnReorder(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {isErrorMsgForColumnReorder}
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDCard>
                </Modal>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        {loading && (
          <Backdrop
            sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <ToastContainer />
        <Footer />
      </DashboardLayout>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getOperationMachineMapReducer: state.getOperationMachineMapReducer,
    getOperationsForDropDownReducer: state.getOperationsForDropDownReducer,
    getPrintersForLabelCreationReducer:
      state.getPrintersForLabelCreationReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,

    getMachineCenterForDropDownReducer:
      state.getMachineCenterForDropDownReducer,

    getMappedMachinesReducer: state.getMappedMachinesReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getOperationMachineMap: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getOperationMachineMap(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    getPrintersForLabelCreation: (jwtToken) =>
      dispatch(getPrintersForLabelCreation(jwtToken)),
    createOperationMachineMap: (payload, jwtToken) =>
      dispatch(createOperationMachineMap(payload, jwtToken)),
    updateOperationMachineMap: (payload, jwtToken) =>
      dispatch(updateOperationMachineMap(payload, jwtToken)),
    deleteOperationMachineMap: (id, userId, jwtToken) =>
      dispatch(deleteOperationMachineMap(id, userId, jwtToken)),
    getMachineCenterForDropDown: (jwtToken) =>
      dispatch(getMachineCenterForDropDown(jwtToken)),
    getMappedMachines: (jwtToken) => dispatch(getMappedMachines(jwtToken)),
    getOperationsForDropDown: (jwtToken) =>
      dispatch(getOperationsForDropDown(jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OperationMachineMap);
